import React, {useEffect, useState} from 'react';
import userManualPDF from "./RMS-korisnicko-uputstvo.pdf"
import "./UserManual.scss"
import {t} from "react-switch-lang";
import {getAppInfo} from "../../services/accountService";
import Swal from "sweetalert2";


const UserManual = () => {
    const [data,setData]=useState()

    const fetchAppInfo = () => {
        getAppInfo()
            .then((r) => {
                setData(r.data);
            })
            .catch((r) => {
                Swal.fire({
                    text: `${t('message.errorApi')}`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                });
            });
    };


    useEffect(() => {
        fetchAppInfo()
    }, []);
    return (
        <div className={"userManualContainer"}>
            <p className={"userManualLabel"}>
                {t('userManual.appName')}: <span>{data?.applicationName}</span>
        </p>
            <p className={"userManualLabel"}>
                {t('userManual.databaseName')} : <span>{data?.databaseName}</span>
            </p>
            <p className={"userManualLabel"}>
                {t('userManual.server')} : <span>{data?.server}</span>
            </p>



            <a href={userManualPDF} download={t('navbar.userManual')}>
                <button  className="report-button userManualDownloadButton">
               {t('sidebar.userManualDownload')}
            </button>
            </a>
            {/*<embed src={userManualPDF} width="100%" height="2100px" />*/}

        </div>
    );
};

export default UserManual;